import { useSubmitQuestionnaire } from '@/composables/questionnaireHelps';
import handleRequest from '@/utils/helpers/handleRequest';
import getServerMessage from '@/utils/api/serverErrors.js';
import useGlobalStore from '@/stores/globalStore';
import { setlanguageByCountry } from '@/plugins/i18n';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>(async to => {
  const { email, token, preview } = to.query;
  if (preview) {
    return;
  }
  if (!email || !token) {
    return '/page-not-found';
  }
  const submitQuestionnaire = useSubmitQuestionnaire();
  const { isError, response, data } = await handleRequest(
    submitQuestionnaire({ email, token }),
  );

  if (isError) {
    return {
      name: 'error',
      query: {
        error: getServerMessage(response, { ignore403: true }),
      },
    };
  }

  const globalStore = useGlobalStore();
  globalStore.setCitySubscriptions(data.season_tickets);
  globalStore.setUserQuestionnaireSettings({
    hide_remote: !!data.is_hide_remote,
    show_non_sustainable_preferred_transports: !!data.show_non_sustainable_preferred_transports,
    ask_off_site_work: !!data.ask_off_site_work,
    custom_questions: Array.isArray(data.custom_questions)
      ? data.custom_questions
      : [],
  });
  globalStore.setUserQuestionnaireInitialCountryId(data.country_id);
  
  // Set language based on country if provided
  if (data.country_id) {
    const country = globalStore.countries.find(
      c => c && Number(c.value) === Number(data.country_id),
    );
    country?.name && setlanguageByCountry(country.name);
  }
});
